module.exports = __webpack_public_path__ + "img/rank.6625b095.svg";